import { formatPostcodeForDisplay } from 'App/helpers/addressHelpers';

angular.module('upFilters').filter('postcodeDisplay', function () {
	return formatPostcodeForDisplay;
});
